import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ConnectVO } from '../../../vo/core/connect.vo';

@Component({
  selector: 'connect-icon-renderer',
  templateUrl: './connect-icon.renderer.html',
  styles: [':host {max-width: 100%}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

/**
 * Renderer des actions sur un modèle de codification dans le grid
 */
export class ConnectIconRenderer implements AgRendererComponent {
  constructor(private cdref: ChangeDetectorRef, public elementRef: ElementRef) {}

  cnx: ConnectVO = null;

  refresh(params: ICellRendererParams): boolean {
    this.cnx = params.data;
    this.cdref.markForCheck();
    return true;
  }

  agInit(params: ICellRendererParams) {
    this.cnx = params.data;
    this.cdref.markForCheck();
  }
}
